<template>
<div id="mission">
  <div class="container-fluid">
    <div class="main">
      <div class="mission-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'mission',

  computed: {
    ...mapGetters({
      'loginState': 'login/loginState'
    })
  }
}
</script>

<style scoped lang="less">
@import '~variables';
.main {
    padding-bottom: 3rem;
}

.mission-content {
  width: 100%;
  display: inline-block;
}

@media (min-width: @screen-md-min){
  .mission-content {
  }
}
</style>
